import { ReceiptsTable } from "@/features/receipts";

export function ReceiptsScreen() {
  return (
    <div className="p-4">
      <div className="mb-6">
        <h1 className="text-3xl font-bold">Receipts</h1>
        <p className="text-gray-600 mt-2">View and manage payment receipts</p>
      </div>
      <ReceiptsTable />
    </div>
  );
}
